/**
 * @file Label 表单标签
 * @description 紧凑表单标签，支持必填星号。
 *
 * @whenToUse 与 Input / Select 等表单控件搭配。
 * @whenNotToUse 页面标题或区块标题（用语义标题标签）。
 */

import type { LabelHTMLAttributes } from 'react'
import { cn } from '@/lib/cn.ts'

export type LabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  /** 显示必填标记 * */
  required?: boolean
}

export function Label({
  required = false,
  className,
  children,
  ...rest
}: LabelProps) {
  return (
    <label
      className={cn(
        'inline-flex items-center gap-1 text-sm font-medium text-foreground',
        className,
      )}
      {...rest}
    >
      {children}
      {required ? (
        <span className="text-danger" aria-hidden>
          *
        </span>
      ) : null}
    </label>
  )
}
